module.exports = __webpack_public_path__ + "img/export-3.ccec2832.svg";